export const InitialValuesProfilJobAccount = {
	/*job: "",*/
	signature: "",
	generalAbilities: "",
	workingRegion: "",
	visitAbilities: "",
	visitTransportations: "",
}